// A tiny typed event hub for IMPERATIVE app lifecycle events — the ones that
// aren't uiState changes (those already fan out through onState). Subsystems
// register reactions with on(); the originating code fires emit(). This is the
// seam that lets a new "when a fresh layout starts, do X" reaction live in its
// own module instead of getting bolted onto FloorModeCtx as another one-off
// callback (which is how resetVisibility started).

export type LifecycleEvent = "new-layout"; // grow this union as events are added

export interface Lifecycle {
  on(event: LifecycleEvent, fn: () => void): void;
  emit(event: LifecycleEvent): void;
}

export function createLifecycle(): Lifecycle {
  const handlers = new Map<LifecycleEvent, (() => void)[]>();
  return {
    on(event, fn): void {
      const list = handlers.get(event);
      if (list) list.push(fn);
      else handlers.set(event, [fn]);
    },
    emit(event): void {
      const list = handlers.get(event);
      if (list) for (const fn of list) fn();
    },
  };
}
